/* eslint-disable no-console */
/* cSpell:ignore xsrf */
import Axios from 'axios';

/**
 * definition:
 * [1] - variant.
 * [2] - map codes.
 * [3] - helper.
 */

// [1] - variant.

// for xsrf
// const PASSPORT = 'el-xsrf'; // @deprecated
// for response headers
const LAND_AREA = 'el-result-code';
// const DEFAULT_HEADER_RES = 'OK';

/**
 * default setting.
 * episode 1
 * normalize setting.
 */
const instance = Axios.create({
  baseURL: process.env.SERVE, // 从配置表读取，可能为相对路径，也可能是绝对路径
  withCredentials: true,
  timeout: 600000, // 10min
  // xsrfCookieName: PASSPORT, // eslint-disable-line
  // xsrfHeaderName: PASSPORT, // eslint-disable-line
});

// [2] - map codes.

// map: which method can be execute. method checking.
const URL_PARAMETERS_METHOD = ['delete', 'get', 'head', 'options'];
const REQUEST_BODY_METHOD = ['post', 'put', 'patch', 'form', 'upload'];
const ALLOWED_METHOD = [...URL_PARAMETERS_METHOD, ...REQUEST_BODY_METHOD];

// map: response status translate.
const statusMessageMap = {
  200: '成功。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '请求受理成功，无数据返回 [No Content]',
  400: '错误的请求格式。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '您的访问被拒绝。',
  404: '您访问的资源不存在。',
  406: '请求的格式不可得。',
  409: '数据版本不一致，操作被禁止。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务端异常，请联系系统管理员。',
  502: '网关错误，请联系系统管理员',
  503: '服务不可用，请联系系统管理员。',
  504: '网关超时，请联系系统管理员。',
};

// [3] - helper.

/**
 * default setting.
 * episode 2
 * request method headers setting.
 *
 * map: request method.
 * */
const instanceResolver = (options) => {
  const { method, headers, ...rest } = options;
  const modifiedMethod = ['form', 'upload'].includes(method) ? 'post' : method;
  const newOptions = {
    ...rest,
    headers: {
      ...headers,
      ...(method === 'form' ? { 'Content-Type': 'application/x-www-form-urlencoded' } : {}),
      ...(method === 'upload' ? { 'Content-Type': 'multipart/form-data' } : {}),
      'el-cid': localStorage.getItem('cid') || '',
    },
    method: modifiedMethod,
    ...(method === 'get'
      ? { params: { ...(rest.params || {}), _t: Date.parse(new Date()) / 1000 } }
      : {}),
  };
  return instance(newOptions);
};
// resolve the headers'  message to show
const headersResolver = (response) => {
  const { headers } = response;
  //  !: LAND_AREA should be [DEFAULT_HEADER_RES] to declare a logical success as normal, or, it must be a logical failure.
  const resultCode = headers[LAND_AREA];
  // TODO: need a map like statusMessageMap to translate resultCode; if there is not a matched resultCode, use statusMessage.
  return { code: resultCode, name: resultCode };
};

// resolve the (status|headers)' message to show
const messageResolver = (response) => {
  const { status, statusText } = response;
  const statusMessage = statusMessageMap[status] || statusText;
  const headersMessage = headersResolver(response).name;
  const resultMessage = headersMessage || statusMessage;
  return resultMessage;
};

/**
 * resolve a formatted object for request response.
 * @param {Boolean} success - whether success or not based on network request.
 * @param {String} message - the message to show. maybe a response status translation, or response headers' 'NG_XXX'
 * @param {Object} data - response body
 * @param {Number} status - response status
 * @param {Boolean} canceled - the request is cancel or not.
 */
const responseResolver = (success, message, data, status, headers, canceled) => ({
  success: !!success,
  message,
  data,
  status,
  canceled: !!canceled,
  headers,
});

/**
 * analysis axios' error to find detail error type
 * @param {Object} error - request error
 */
const errorResolver = (error = {}) => {
  const { message } = error;
  if (message.includes('timeout of')) return { message: '请求超时' };
  if (message.includes('Network Error')) return { message: '网络异常' };
  if (message.includes('Request aborted')) return { message: '请求被取消或中断', canceled: true };
  if (message.includes('maxContentLength size of')) return { message: '请求体过长' };
  return { message: '未知错误' };
};

/**
 * fetch resolver.
 * @param {Object} option - axios config, can be over-write default setting above.
 */
const fetch = async (options) => {
  const { method } = options;
  options.headers = options.headers || {};
  if (localStorage.getItem('Authorization')) {
    options.headers['Authorization'] = localStorage.getItem('Authorization');
  }
  const lowerMethod = method.toLocaleLowerCase();

  if (!ALLOWED_METHOD.includes(lowerMethod)) {
    const message = `expect one of [${ALLOWED_METHOD.join('|')}] method, but got [${method}]`;
    throw SyntaxError(message);
  }

  let res = {};

  try {
    console.log('[fetch] request : ', Axios.getUri(options));
    // normalize handling.
    let response = await instanceResolver({ ...options, method: lowerMethod });
    const { data, status, headers } = response;
    res = responseResolver(true, messageResolver(response), data, status, headers);
  } catch (e) {
    // error handling.
    if (e.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log('[fetch] - falls out of the range of 2xx');
      const { data, status } = e.response;
      res = responseResolver(false, messageResolver(e.response), data, status);
    } else if (e.request) {
      // The request was made but no response was received
      const { message, canceled } = errorResolver(e);
      console.log('[fetch] - The request was made but no response was received', message);
      res = responseResolver(false, message, undefined, undefined, canceled);
    } else if (Axios.isCancel(e)) {
      // canceled by user, not utils.
      console.log('[fetch] cancel: request abort', e);
      const { message, canceled } = errorResolver(e);
      res = responseResolver(false, message, undefined, undefined, canceled);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('[fetch] error: request setting triggered an Error', e);
      throw Error(e.message);
    }
  } finally {
    console.log(' request done. ');
  }

  return res;
};

/**
 * generator
 */
URL_PARAMETERS_METHOD.forEach(
  (method) => (fetch[method] = (url, config) => fetch({ ...config, url, method })),
);
REQUEST_BODY_METHOD.forEach(
  (method) => (fetch[method] = (url, data, config) => fetch({ ...config, url, data, method })),
);

export default fetch;
